module.exports = __webpack_public_path__ + "img/Den-eldre-Edda_Utsnitt-fra-treskjering-Hylestad-stavkirke.05db64cc.jpg";